module.exports = __webpack_public_path__ + "gb-nir.svg?080d05670e1d7ad2d3b7315edefa3653";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/gb-nir.svg
// module id = 1714
// module chunks = 0